import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { media } from "@helium10/re-ui-components";
import styled from "styled-components";
import { Input, Label } from "../Styles";
export const LabeledName = ({ placeholder, label, id, ...rest }) => {
    return (_jsxs(Container, { children: [_jsx(Label, { htmlFor: id, children: label }), _jsx(Input, { ...rest, id: id, placeholder: placeholder, size: "200" })] }));
};
const Container = styled.div `
  min-width: 100%;
  font-size: 0;

  ${media.desktop} {
    min-width: 230px;
  }
`;
